import * as React from 'react';
import axios from 'axios';
import { ConnectedListContainer } from '../../common/components/list-container';
import ProviderListItem from './list-item';
import { ConnectedFiltersHeader } from '../../common/components/filters-header';
import { ConnectedFilterTextbox } from '../../common/components/filter-textbox';
import { ConnectedFilterDropdown } from '../../common/components/filter-dropdown';
import { ConnectedFilterMultiSelectDropdown } from '../../common/components/filter-multi-select-dropdown';
import { ConnectedFilterRadio } from '../../common/components/filter-radio';
import { ConnectedFilterChecklist } from '../../common/components/filter-checklist';
import { ConnectedSort } from '../../common/components/sort-options';
import { ConnectedClearAll } from '../../common/components/clear-all';
import ConnectedDashBoard from '../../common/components/result-dashboard';
import { ConnectedScrollToTop } from '../../common/components/scroll-to-top';
import { AppExternalProps } from '../../event/components/app';

import { connect } from 'react-redux';
import { IAppState } from '../../common/classes/app';
import { localStoreCacheKey } from '../../common/redux-state';

interface StateToProps {
    isMobile: boolean;
    hideSpecialtiesFilter: boolean;
    hideZipOrCityFilter: boolean;
    hideGenderFilter: boolean;
    hideLanguageFilter: boolean;
    hideProviderDesignationFilter: boolean;
    filters: string;
    hideHospitalPracticeFilter: boolean;
    hideNetworkFilter: boolean;
    hideCity: boolean;
    searchWithinTitle?: string;
    customDistanceErrorMessage?: string;
    showDistanceFilter: boolean;
    enableAdvanceLocationLookup: boolean;
}

interface ExternalProps {
    hospitalSearch: boolean
    locationSearchUrl: string
    radiusSearch: boolean,    
    searchByLocation: boolean,
    sortByLocation: boolean
}


type ProviderAppProps = StateToProps & AppExternalProps & ExternalProps;

const ProviderAppBase: React.StatelessComponent<ProviderAppProps> = props => {

    function ClearCache() {

        localStorage.removeItem(localStoreCacheKey());
    }

    const additionalInfo = window["additionalInfo"];

    return (
        <div>
            <div className="adage-search-input">
                <div className="adage-search-input-inner">
                    <h1>Find a Provider</h1>
                    <ConnectedFilterTextbox searchByLocation={props.searchByLocation} clickToSubmit={true} property="QueryValue" title="" defaultTextBoxValue={props.searchBoxDefault} showMoreLink={true} />
                </div>
                {
                    additionalInfo && additionalInfo.data && additionalInfo.data.length > 0 ? (<section className="adage-block adage-wysiwyg-block-container">
                        <div className="adage-block-inner adage-wysiwyg-block">
                            <div className="rich-text"> <div dangerouslySetInnerHTML={{ __html: additionalInfo.data }} /></div></div></section>) : null
                }
            </div>
            <div className="adage-search">
                <div className="adage-search-rail">
                    <div className="adage-search-filters adage-search-rail-inner adage-search-rail-inner-js">
                        <ConnectedFiltersHeader />

                        <div id="searchFilters" className="adage-search-filters-content" aria-hidden={props.isMobile ? "true" : null}>
                            {
                                props.hospitalSearch ?
                                    <div className="adage-search-filters-facets">
                                        <div className="adage-search-filters-facets-column">
                                            <div className="adage-search-facet-group">
                                                <p> You are now searching within a Hospital Network.&nbsp;
                                                <a href={props.locationSearchUrl} onClick={ClearCache}>Click Here</a>&nbsp;
                                                                                            to go back to Site Provider Search.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }
                            <div className="adage-search-reset">
                                <ConnectedClearAll text="Clear All" />
                            </div>

                            <div className="adage-search-filters-facets">
                                <div className="adage-search-filters-facets-column">
                                    {!props.hideSpecialtiesFilter ?
                                        <div className="adage-search-facet-group">
                                            <h3 className="adage-search-facet-group-title">Provider Expertise</h3>
                                            <ConnectedFilterMultiSelectDropdown property="specialties" title="Specialty" defaultOption={{ text: "All Specialties", value: "" }} />
                                        </div>
                                        : null
                                    }

                                    <div className="adage-search-facet-group">
                                        <h3 className="adage-search-facet-group-title">Location</h3>
                                        {!props.hideHospitalPracticeFilter ? <ConnectedFilterMultiSelectDropdown property="hospital" title="Hospitals and Outpatient Centers" defaultOption={{ text: "All Hospitals and Outpatient Centers", value: "" }} /> : null}
                                        {!props.hideHospitalPracticeFilter ? <ConnectedFilterMultiSelectDropdown property="practice" title="Provider Practices" defaultOption={{ text: "All Provider Practices", value: "" }} /> : null}
                                        {!props.hideZipOrCityFilter && !props.hideCity ? <ConnectedFilterTextbox placeHolder="Enter a City" clickToSubmit={false} property="city" title="City" showMoreLink={false} /> : null}
                                        {!props.hideZipOrCityFilter ? <ConnectedFilterTextbox showMoreLink={false} placeHolder="Enter a Zip" property="zip" clickToSubmit={false} title="Zip" /> : null}
                                        {props.radiusSearch && !props.hideZipOrCityFilter ? <ConnectedFilterDropdown property="radius" title={props.searchWithinTitle ? props.searchWithinTitle : "Search Radius from ZIP"} defaultOption={{ text: "Select a Distance", value: "Select a Distance" }} /> : null}
                                    </div>


                                </div>

                                <div className="adage-search-filters-facets-column">
                                    {!(props.hideGenderFilter && props.hideLanguageFilter && props.hideProviderDesignationFilter && props.hideNetworkFilter) ?
                                        <div className="adage-search-facet-group">
                                            <h3 className="adage-search-facet-group-title">Provider Information</h3>
                                            {!props.hideGenderFilter ? <ConnectedFilterRadio property="gender" title="Gender" defaultOption={{ text: "No Preference", value: "" }} /> : null}
                                            {!props.hideLanguageFilter ? <ConnectedFilterDropdown property="language" title="Language" defaultOption={{ text: "No Preference", value: "" }} /> : null}
                                            {!props.hideProviderDesignationFilter ? <ConnectedFilterChecklist property="designation" title="Provider Designation" /> : null}
                                            {!props.hideNetworkFilter ? <ConnectedFilterChecklist property="network" title="Health Networks" /> : null}
                                        </div>
                                        : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="adage-search-main">
                    <ConnectedListContainer sortByLocation={props.sortByLocation} itemType="Providers" providerFilters={props.filters} listItemComponent={props => <ProviderListItem key={props.id} {...props} />} />
                </div>

                <ConnectedScrollToTop />
            </div>
        </div>
    )
}

function mapStateToProps(state: IAppState): StateToProps {
    return {
        isMobile: state.responsiveState.isMobile,
        hideSpecialtiesFilter: state.filtersState.hideSpecialtiesFilter,
        hideZipOrCityFilter: state.filtersState.hideZipOrCityFilter,
        hideGenderFilter: state.filtersState.hideGenderFilter,
        hideLanguageFilter: state.filtersState.hideLanguageFilter,
        hideProviderDesignationFilter: state.filtersState.hideProviderDesignationFilter,
        hideHospitalPracticeFilter: state.filtersState.hideHospitalPracticeFilter,
        hideNetworkFilter: state.filtersState.hideNetworkFilter,
        filters: Object.keys(state.filtersState.filters).sort().map(filterKey => `${filterKey}=${state.filtersState.filters[filterKey]}`).join('&'),
        hideCity: state.filtersState.hideCityFilter,
        searchWithinTitle: state.filtersState.searchWithinTitle,
        customDistanceErrorMessage: state.listingState.customDistanceErrorMessage,
        showDistanceFilter: state.listingState.showDistanceFilter,
        enableAdvanceLocationLookup: state.listingState.enableAdvanceLocationLookup
    }
}



export const ProviderApp = connect(mapStateToProps)(ProviderAppBase);